const PropTypes = require('prop-types');
//@vendors
const React = require('react');
//@commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');

class ExtractsFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            dateSelected: immFilter.get('date').get('selected'),
            dateFrom: immFilter.get('date').get('from'),
            dateTo: immFilter.get('date').get('to'),
            typeOfDocument: '',
            contract: '',
            contractNumber: ''
        };

        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleFormSubmit() {
        const { setFilter, onCloseClick } = this.props;
        const { dateFrom, dateTo, dateSelected, typeOfDocument, contractNumber } = this.state;

        setFilter({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            typeOfDocument: {
                type: typeOfDocument
            },
            contract: {
                number: contractNumber
            }

        });
        onCloseClick();
    }

    render() {
        const { immFilter, isOpen, onCloseClick } = this.props;
        const contentModal = (
            <DateFilter
                immFilter={immFilter.get('date')}
                onChangeMin={this.handleChangeDateMin}
                onChangeMax={this.handleChangeDateMax}
                onChangeSelected={this.handleChangeDateSelected}
                last={true}
            />
        );
        return (
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="profileDocumentation-filterTitle"
            />
        );
    }
}

ExtractsFilter.propTypes = {
    groupSelected: PropTypes.string,
    documents: PropTypes.object,
    immFilter: PropTypes.object,
    immTypes: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    setFilter: PropTypes.func
};

module.exports = ExtractsFilter;
